import { z } from 'zod';

import { KitCompositionModeSchema, KitPriceAdjustmentTypeSchema } from './kit.schemas.js';

export const RegisterKitBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  sku: z.string().trim().max(50).optional(),
  categoryId: z.uuid().optional(),
  internalNotes: z.string().trim().max(5000).optional(),
  compositionMode: KitCompositionModeSchema.optional(),
  priceAdjustmentType: KitPriceAdjustmentTypeSchema.optional(),
  priceAdjustmentValue: z
    .string()
    .regex(/^-?\d+$/)
    .optional(),
});

export const RegisterKitResponseSchema = z.object({
  kitId: z.uuid(),
});

export type RegisterKitBody = z.infer<typeof RegisterKitBodySchema>;
export type RegisterKitResponse = z.infer<typeof RegisterKitResponseSchema>;
